import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const Vessel = AiseaApiFactory.get("vessel");

export default {
  /**
   * 選択中の船舶情報を取得
   *
   * @param context
   * @param vesselId
   * @returns {*}
   */
  fetch: (context, vesselId) => {
    return Vessel.getVessel(
      vesselId
    ).then(response => {

      context.commit("CREATE", response.data);
    });
  },
  /**
   * データ全削除
   *
   * @param context
   */
  clear: (context) => {
    context.commit("CLEAR");
  }
}
